import {create} from 'zustand';

const MAX_CALLS = 150;

const useDevPanelStore = create(set => ({
  open: false,
  paused: false,
  selectedCallId: null,
  calls: [],
  detailTab: 'prompt',
  codeFormat: 'curl',

  setOpen: open => set({open}),
  toggleOpen: () => set(state => ({open: !state.open})),
  setPaused: paused => set({paused}),
  setSelectedCallId: selectedCallId => set({selectedCallId}),
  setDetailTab: detailTab => set({detailTab}),
  setCodeFormat: codeFormat => set({codeFormat}),
  clearCalls: () => set({calls: [], selectedCallId: null}),

  addCall: call =>
    set(state => {
      if (state.paused) return state;
      const calls = [call, ...state.calls].slice(0, MAX_CALLS);
      return {calls};
    }),

  updateCall: (id, patch) =>
    set(state => ({
      calls: state.calls.map(call => (call.id === id ? {...call, ...patch} : call)),
    })),
}));

export default useDevPanelStore;
